import {
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  TextInput,
  Pagination,
  FunctionField,
  BooleanField,
  useSidebarState,
} from "react-admin";

import { FILTER_LIMITS } from "@/constants/filters";
import { ClientAppField } from "@/modules/clientApps/components/ClientAppField";
import { DeviceTypeField } from "@/modules/deviceTypes/components/DeviceTypeField";

import { DeviceTypeArrayInput } from "../../deviceTypes/components/DeviceTypeArrayInput";
import { TrafficSourceField } from "../../trafficSources/components/TrafficSourceField";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

export const CampaignsList = () => {
  const [open] = useSidebarState();

  return (
    <List
      actions={<ListActions />}
      filters={[
        <TextInput key="id" source="id" alwaysOn />,
        <TextInput key="title" source="title" alwaysOn />,
        <TextInput key="campaignId" source="campaignId" alwaysOn />,
        <DeviceTypeArrayInput
          key="deviceTypeId"
          source="deviceTypeId"
          alwaysOn
        />,
      ]}
      storeKey={false}
      perPage={FILTER_LIMITS[0]}
      pagination={<Pagination rowsPerPageOptions={FILTER_LIMITS} />}
      sort={{ field: "id", order: "DESC" }}
    >
      <DatagridConfigurable
        className={`datagrid-scroll ${!open ? "collapsed" : ""}`}
        bulkActionButtons={false}
        rowClick="edit"
        omit={["createdAt", "updatedAt"]}
      >
        <TextField source="id" sortable={false} />
        <TextField source="title" sortable={false} />
        <TextField source="trackerId" sortable={false} />
        <TrafficSourceField source="trafficSource" sortable={false} />
        <TextField source="campaignId" sortable={false} />
        <FunctionField
          source="tds"
          render={(record: { tds: unknown[] }) =>
            `Total records: ${record.tds.length}`
          }
          sortable={false}
        />
        <ClientAppField source="clientAppId" sortable={false} />
        <BooleanField source="installPostbackUrlEnabled" sortable={false} />
        <TextField source="installPostbackUrl" sortable={false} />
        <BooleanField source="trialPostbackUrlEnabled" sortable={false} />
        <TextField source="trialPostbackUrl" sortable={false} />
        <BooleanField
          source="subscriptionPostbackUrlEnabled"
          sortable={false}
        />
        <TextField source="subscriptionPostbackUrl" sortable={false} />
        <BooleanField source="active" sortable={false} />
        <DeviceTypeField source="deviceTypeId" sortable={false} />
        <TextField source="authorId" sortable={false} />
      </DatagridConfigurable>
    </List>
  );
};
